/* eslint-disable object-curly-newline */
import _ from 'underscore';
import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import { TooltipHost, TooltipOverflowMode } from '@bingads-webui-react/fabric-control';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getStyle } from './styles';

export const splitString = (text, substr) => {
  //
  if (!text || !substr || _.isEmpty(substr)) {
    return [{ matched: false, text, idx: 0 }];
  }

  // case-insensitive
  const lowerText = text.toLowerCase();
  const lowerSubstr = substr.toLowerCase();

  let startIndex = 0;
  const fragments = [];

  while (startIndex < text.length) {
    const index = lowerText.indexOf(lowerSubstr, startIndex);
    if (index === -1) {
      fragments.push({ matched: false, text: text.substring(startIndex) });
      break;
    } else if (index > startIndex) {
      fragments.push({ matched: false, text: text.substring(startIndex, index) });
      fragments.push({ matched: true, text: text.substring(index, index + substr.length) });
      startIndex = index + substr.length;
    } else {
      fragments.push({ matched: true, text: text.substring(index, index + substr.length) });
      startIndex = index + substr.length;
    }
  }

  // add an idx field for each fragment
  const fragmentsWithIndex = fragments.map((f, idx) => ({ ...f, idx }));
  return fragmentsWithIndex;
};

export const TextWithHighlight = ({
  text: txt, highlightedText, highlightedClassname, enableTooltip,
}) => {
  const textFragments = splitString(txt, highlightedText);
  const classes = useDefaultStyles(getStyle);

  const content = (
    <span>
      {
        textFragments.map(({ matched, text, idx }) =>
          <span key={`f${idx}`} className={classnames(matched && highlightedClassname)}>{text}</span>)
      }
    </span>
  );

  return enableTooltip ? (
    <TooltipHost
      overflowMode={TooltipOverflowMode.Self}
      className={classes.tooltipClass}
      hostClassName={classes.overflow}
      content={txt}
    >
      {content}
    </TooltipHost>
  ) : content;
};

TextWithHighlight.propTypes = {
  text: PropTypes.string,
  highlightedText: PropTypes.string,
  highlightedClassname: PropTypes.string,
  enableTooltip: PropTypes.bool,
};

TextWithHighlight.defaultProps = {
  text: '',
  highlightedText: undefined,
  highlightedClassname: 'highlighted-text',
  enableTooltip: false,
};
